export default __webpack_public_path__ + "static/media/twitter.0b86c17d.svg";